








































































































































import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import Modal from '@/components/Modal.vue';
import { User } from '@/types';
import GenericButton from '@/components/GenericButton.vue';
import LoginService from '@/services/login.service';
import QrcodeVue from 'qrcode.vue';
import Dialog from '@/components/Dialog.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import {copyToClipboard} from '@/classes/utils';

@Component({
  methods: {copyToClipboard},
  components: {
    ConfirmButton,
    CancelButton,
    Dialog,
    Modal,
    GenericButton,
    QrcodeVue,
  },
})
export default class UserProfileForm extends Vue {
  @Prop({ default: false }) private modalVisible!: boolean;
  @Prop() private closeModal!: any;
  @Prop({ default: () => ({first_name: '', last_name: '', email: '', mfa_enabled: false}) }) private user!: User;
  @Action private addToastErrorMessage: any;
  @Action private updateMeAsync: any;
  private details: any = {};
  private loading: boolean = false;
  private recoveryCodesSaved: boolean = false;
  private showRecoveryCodes: boolean = false;
  private passwordPrompt: boolean = false;
  private recoveryCode: string = '';
  private currentPassword: string = '';
  private newPassword: string = '';
  private confirmPassword: string = '';
  private totpUri: string = '';
  private totpSecret: string = '';
  private totpCode: string = '';
  private password: string = '';

  public created() {
    const apiJobs: Array<Promise<void>> = [];
    Promise.all(apiJobs);
  }

  private showModal() {
    this.modalVisible = true;
  }

  private downloadCodes(codes: string[]) {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(codes.join('\n')));
    element.setAttribute('download', `daizy_recovery_${(new Date().toJSON().slice(0, 10))}`);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);

    this.recoveryCodesSaved = true;
  }


  private async saveProfile() {
    const res = await this.updateMeAsync({payload: this.user });
    if (res) {
      this.closeModal();
    }
  }

  private async passwordConfirm() {
    await (this.user.mfa_enabled ? this.disableMFA() : this.registerMFA());
  }

  private showPasswordDialog() {
    this.passwordPrompt = true;
    this.$nextTick(() => (this.$refs.password as any).focus());
  }

  private async registerMFA() {
    this.loading = true;
    try {
      const result = await LoginService.registerTOTP(this.password);
      this.totpUri = result.totpUri;
      this.totpSecret = result.totpSecret;
      this.$nextTick(() => (this.$refs.otp as any).focus());
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage('Failed to register MFA: ' + err.message);
    } finally {
      this.loading = false;
      this.password = '';
    }
  }

  private async disableMFA() {
    this.loading = true;
    try {
      await LoginService.disableTOTP(this.password);
      this.user.mfa_enabled = false;
      this.passwordPrompt = false;
    }  catch (e) {
      const err = e as Error;
      this.addToastErrorMessage('Failed to disable MFA: ' + err.message);
    } finally {
      this.loading = false;
      this.password = '';
    }
  }

  private async enableMFA() {
    if (this.totpCode.length < 6) {
      return;
    }
    this.loading = true;
    try {
      this.recoveryCode = (await LoginService.enableTOTP(this.totpCode)).recoveryCode;
      this.totpUri = '';
      this.user.mfa_enabled = true;
      this.showRecoveryCodes = true;
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage('Failed to enable MFA: ' + err.message);
    } finally {
      this.password = '';
      this.loading = false;
    }
  }

  private resetProps() {
    this.recoveryCodesSaved = false;
    this.showRecoveryCodes = false;
    this.passwordPrompt = false;
    this.totpUri = '';
    this.totpSecret = '';
    this.totpCode = '';
    this.password = '';
    this.recoveryCode = '';
  }
}
